import { Model as BaseModel } from 'vue-api-query'
import env from '@/services/env'
import { serialize } from 'object-to-formdata'
import values from 'lodash/values'
import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import upperCase from 'lodash/upperCase'

export default class Model extends BaseModel {
  baseURL () {
    return env.apiUrl
  }

  // implement a default request method
  async request (config) {
    if (upperCase(get(config, 'data._method')) === 'PUT') {
      config.method = 'POST'
    }

    const hasUpload = !isEmpty(filter(values(config.data), value => {
      return value instanceof File
    }))

    if (hasUpload && config.method !== 'PUT') {
      config.data = serialize(config.data, { indices: true })
    }

    // if (hasUpload) {
    //   config.data = serialize(config.data, { indices: true })
    // }

    return this.$http.request(config)
  }
}
